module.exports = __webpack_public_path__ + "static/media/9_ДОКЛАД _Политика_20160622.efdf7433.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/9_ДОКЛАД _Политика_20160622.pdf
// module id = 172
// module chunks = 0